var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiSummaryIcon = function SvgAiSummaryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-summary-icon_svg__a)",
    d: "M6.658 2.771q.011.001.014.014c.221 3.508 3.07 6.314 6.63 6.533q.013.001.013.014a.014.014 0 0 1-.013.014c-3.56.218-6.409 3.024-6.63 6.532a.014.014 0 0 1-.014.014.014.014 0 0 1-.014-.014c-.222-3.508-3.07-6.314-6.63-6.532A.014.014 0 0 1 0 9.332q.001-.013.013-.014c3.561-.219 6.41-3.025 6.63-6.533q.002-.013.015-.014M12.263.108q.007.001.008.008c.124 1.969 1.723 3.543 3.722 3.666a.008.008 0 0 1 0 .015c-1.999.123-3.598 1.698-3.722 3.667a.01.01 0 0 1-.008.008.01.01 0 0 1-.008-.008c-.124-1.969-1.723-3.544-3.721-3.667a.01.01 0 0 1-.008-.007q.001-.008.008-.008c1.998-.123 3.597-1.697 3.721-3.666q.001-.007.008-.008"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-summary-icon_svg__a",
    x1: 16,
    x2: -1.234,
    y1: 0.108,
    y2: 10.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01FABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0164FD"
  })))));
};
export default SvgAiSummaryIcon;